import { NgModule } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { BadgeModule } from 'primeng/badge'
import { ButtonModule } from 'primeng/button'
import { CheckboxModule } from 'primeng/checkbox'
import { DatePickerModule } from 'primeng/datepicker'
import { InputNumberModule } from 'primeng/inputnumber'
import { InputTextModule } from 'primeng/inputtext'
import { MultiSelectModule } from 'primeng/multiselect'
import { Popover } from 'primeng/popover'
import { SelectModule } from 'primeng/select'

import { GlobalSearchModule } from '@app/components/global-search/global-search.module'
import { StopClickPropagationDirective } from '@app/directives/stop-click-propagation.directive'

import { ConfigureFiltersComponent } from './configure-filters'
import { ConfigureFiltersService } from './configure-filters.service'

@NgModule({
  imports: [
    FormsModule,
    MultiSelectModule,
    Popover,
    InputTextModule,
    InputNumberModule,
    DatePickerModule,
    SelectModule,
    CheckboxModule,
    ButtonModule,
    StopClickPropagationDirective,
    BadgeModule,
    GlobalSearchModule,
    ConfigureFiltersComponent,
  ],
  exports: [
    ConfigureFiltersComponent,
  ],
  providers: [
    ConfigureFiltersService,
  ],
})
export class ConfigureFiltersModule {}
